export const SETTINGS_SET_BASE_URLS = 'SETTINGS_SET_BASE_URLS';
export const SET_CHOOSEN_MAP_MODE = 'SET_CHOOSEN_MAP_MODE';
